/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Case, Switch } from "react-if";
import styled from "styled-components";
import { Checkbox, Table } from "@nordcloud/gnui";
import { SidebarItemTextColumn } from "~/components";
import { ColumnType, Item } from "~/types";

type Props = {
  key: string;
  item: Item;
  showValueInOptions?: boolean;
  onSelect: (i: string) => void;
  selectedOptions?: string[];
  disabledOptions: { id: string; state: boolean }[];
};

export function NotificationGroupSidebarItem({
  item,
  onSelect,
  showValueInOptions,
  selectedOptions,
  disabledOptions,
}: Props) {
  const isDisabled =
    disabledOptions.find(({ id }) => id === item.id) !== undefined;

  return (
    <Table.tr
      title={item?.name}
      onClick={() => !isDisabled && onSelect(item.id)}
      aria-disabled={isDisabled}
    >
      <CheckboxColumn disabled={isDisabled}>
        <Checkbox
          aria-labelledby={item?.name}
          withoutLabel
          checked={selectedOptions?.includes(item.id)}
          defaultChecked={
            disabledOptions.find(({ id }) => id === item.id)?.state
          }
          disabled={isDisabled}
          css={{ cursor: isDisabled ? "no-drop" : "pointer" }}
          readOnly
        />
      </CheckboxColumn>
      {item.columns?.map((column, index) => (
        <Switch key={`${item.id}${index}`}>
          <Case condition={column.type === ColumnType.text}>
            <SidebarItemTextColumn
              column={column}
              isDisabled={isDisabled}
              showValueInOptions={showValueInOptions}
            />
          </Case>
        </Switch>
      ))}
    </Table.tr>
  );
}

const CheckboxColumn = styled(Table.td)<{ disabled: boolean }>`
  text-align: center;
  vertical-align: middle;
  user-select: none;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`;
